*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  user-select: none;
  display: inline-flex;
}

svg {
  display: block;
  color: var(--wui-icon-color, inherit);
}

svg.spin {
  animation: wui-icon-spin 0.6s linear infinite;
}

@keyframes wui-icon-spin {
  to {
    transform: rotate(360deg);
  }
}
